import { Box } from '@mui/material';

import { selectIsCreatingTourEvent } from '@/domain/project-tour-ontour/project-tour-ontour.selectors';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSSecondaryButton } from '@/ui/components/button/FSSecondaryButton';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

export function FooterWithButtons({
  onClickSubmit,
  onClickCancel,
}: {
  onClickSubmit: () => void;
  onClickCancel: () => void;
}) {
  const isCreatingTourEvent = useAppSelector(selectIsCreatingTourEvent);

  return (
    <Box display={'flex'} alignItems={'center'} justifyContent={'end'}>
      <FSSecondaryButton sx={{ ml: 1 }} onClick={onClickCancel}>
        {translate('Form.cancel')}
      </FSSecondaryButton>
      <FSPrimaryButton
        sx={{ ml: 1 }}
        disabled={isCreatingTourEvent}
        onClick={onClickSubmit}
      >
        {translate('Form.validate')}
      </FSPrimaryButton>
    </Box>
  );
}
